export default __webpack_public_path__ + "static/media/fk.af6dd5a3.svg";